module.exports = __webpack_public_path__ + "img/bg-pattern-circles-light.2b18cb69.svg";